import { __exports as TokenGeneratorBase } from './_virtual-TokenGeneratorBase.js';

var hasRequiredTokenGeneratorBase;

function requireTokenGeneratorBase () {
	if (hasRequiredTokenGeneratorBase) return TokenGeneratorBase;
	hasRequiredTokenGeneratorBase = 1;

	Object.defineProperty(TokenGeneratorBase, "__esModule", {
	  value: true
	});
	TokenGeneratorBase.default = void 0;
	let TokenGeneratorBase$1 = class TokenGeneratorBase {
	  getValidationErrors(presentationInfo) {
	    const validationErrors = [];
	    try {
	      this.validateParameters(presentationInfo);
	    } catch (error) {
	      error.forEach(errorMessage => validationErrors.push(errorMessage));
	    }
	    return validationErrors.join();
	  }
	};
	TokenGeneratorBase.default = TokenGeneratorBase$1;
	
	return TokenGeneratorBase;
}

export { requireTokenGeneratorBase as __require };
//# sourceMappingURL=vp-js-token-engine-build-tokenGenerators-TokenGeneratorBase.js.map
